<template>
    <div>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6 w-full">
            <div class="flex items-center space-x-2">
                <jet-secondary-button type="button"
                                      @click="refreshOrder">
                    <ArrowPathIcon class="h-5 w-5"></ArrowPathIcon>
                </jet-secondary-button>

                <jet-secondary-button type="button"
                                      v-if="order.refundable"
                                      @click="refundOrder">
                    {{ $t('orders.refund') }}
                </jet-secondary-button>

                <jet-secondary-button type="button" @click.prevent="toggleEdit" v-if="!editing">
                    {{ $t('actions.edit') }}
                </jet-secondary-button>

                <jet-secondary-button type="button" @click.prevent="toggleEdit" v-if="editing">
                    <XMarkIcon class="h-5 w-5"></XMarkIcon>
                </jet-secondary-button>

                <primary-button type="button" @click.prevent="save" v-if="editing">
                    <CheckIcon class="h-5 w-5"></CheckIcon>
                </primary-button>

                <div class="flex flex-col sm:flex-row space-x-2" v-if="editing">
                    <jet-label for="releaseEvents" :value="$t('orders.releaseEvents')"/>
                    <checkbox id="releaseEvents" :checked="form.dispatchEvents"
                              v-model="form.dispatchEvents"></checkbox>
                </div>


            </div>
            <order-state :shipping="false" :state="order.payment"></order-state>
            <order-state :shipping="true" :state="order.fulfillment"></order-state>

            <div class="">
                <order-head :order="order"></order-head>
            </div>
            <div class="">
                <order-address :title="$t('orders.shipping')"
                               :order-id="order.id"
                               :address="order.shipping"></order-address>
            </div>

            <div class="">
                <order-address :title="$t('orders.billing')"
                               :order-id="order.id"
                               :address="order.billing"></order-address>
            </div>

            <div class="">
                <order-documents :deliveryNotes="deliveryNotes" :order="order"></order-documents>
            </div>

            <div class="">
                <order-contact :address="order.billing"></order-contact>
            </div>
            <div class="">
                <order-tracking :code="order.tracking_code" :returnCode="order.return_tracking_code"></order-tracking>
            </div>

        </div>

        <line-items :line-items="lineItems"
                    :form="form"
                    :payment-states="paymentStates"
                    :fulfillment-states="fulfillmentStates"
                    :editing="editing"></line-items>
    </div>

</template>

<script>
import OrderTracking from "@/Pages/Sales/Order/Components/OrderTracking";
import OrderContact from "@/Pages/Sales/Order/Components/OrderContact";
import OrderAddress from "@/Pages/Sales/Order/Components/OrderAddress";
import OrderHead from "@/Pages/Sales/Order/Components/OrderHead";
import OrderState from "@/Pages/Sales/Order/Components/OrderState";
import Detail from "@/Pages/Sales/Order/Detail";
import AppLayout from "@/Layouts/AppLayout";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import PrimaryButton from "@/Jetstream/PrimaryButton";
import JetLabel from "@/Jetstream/Label";
import LineItems from "@/Pages/Sales/Order/Components/LineItems";
import {ArrowPathIcon, CheckIcon, XMarkIcon} from "@heroicons/vue/24/outline";
import {ref} from "vue";
import Checkbox from "@/Jetstream/Checkbox";
import {useForm} from "@inertiajs/vue3";
import OrderDocuments from "@/Pages/Sales/Order/Components/OrderDocuments";

export default {
    name: "Overview",
    props: ['order', 'paymentStates', 'fulfillmentStates', 'lineItems', 'deliveryNotes'],
    layout: [AppLayout, Detail],
    components: {
        OrderDocuments,
        OrderTracking,
        OrderContact,
        OrderAddress,
        OrderHead,
        OrderState,
        JetSecondaryButton,
        ArrowPathIcon,
        LineItems,
        PrimaryButton,
        JetLabel,
        Checkbox,
        XMarkIcon,
        CheckIcon
    },
    setup(props) {
        const editing = ref(false);

        const form = useForm({
            lineItems: props.lineItems,
            dispatchEvents: false,
        });

        return {
            editing,
            form
        }
    },
    methods: {
        refreshOrder() {
            this.$inertia.put(this.route('sales.orders.refresh', this.order), {}, {
                preserveScroll: true,
                onSuccess: () => this.$notify({
                    group: "main",
                    title: 'actions.success',
                    text: 'orders.refresh'
                }, 2000)
            })
        },
        refundOrder() {
            this.$inertia.put(this.route('sales.orders.refund', this.order), {}, {
                preserveScroll: true,
                preserveState: false,
                onSuccess: () => this.$notify({
                    group: "main",
                    title: 'actions.success',
                    text: 'orders.refunded'
                }, 2000)
            })
        },
        toggleEdit() {
            if (this.editing) {
                this.form.reset()
            }
            this.editing = !this.editing;
        },
        save() {
            this.form.put(this.route('sales.orders.lineItems.update', this.order.id), {
                    preserveState: false,
                    preserveScroll: true,
                    onSuccess: () => {
                        this.$notify({
                            group: "main",
                            title: 'actions.success',
                            text: 'orders.updated'
                        }, 2000);
                    }
                }
            )
        }
    }
}
</script>

<style scoped>

</style>
